import api from "@/services/api";
import { 
  VendorLibraryListResponse, 
  VendorLibraryItem, 
  VendorLibrarySavePayload, 
  VendorLibrarySaveResponse, 
  VendorLibraryUpdatePayload, 
  VendorLibraryUpdateResponse 
} from "@/types/vendorSetup.types";

const vendorLibraryInformation = {
  // Get vendor library list
  getVendorLibraryData: async (): Promise<VendorLibraryListResponse> => {
    try {
      const response = await api.vendorServiceAPI.get('/vendor/library/list');
      return response.data;
    } catch (error) {
      console.error("Error fetching vendor library data:", error);
      throw error;
    }
  },

  // Get specific vendor library document
  getVendorLibraryDocument: async (id: string, includeData: boolean = false): Promise<VendorLibraryItem> => {
    try {
      const response = await api.vendorServiceAPI.get(`/vendor/library/get/${id}?data=${includeData}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching vendor library document:", error);
      throw error;
    }
  },

  // Save new vendor library document
  saveVendorLibraryDocument: async (payload: VendorLibrarySavePayload): Promise<VendorLibrarySaveResponse> => {
    try {
      const response = await api.vendorServiceAPI.post('/vendor/library/save', payload);
      return response.data;
    } catch (error) {
      console.error("Error saving vendor library document:", error);
      throw error;
    }
  },

  // Update existing vendor library document
  updateVendorLibraryDocument: async (id: string, payload: VendorLibraryUpdatePayload): Promise<VendorLibraryUpdateResponse> => {
    try {
      const response = await api.vendorServiceAPI.put(`/vendor/library/update/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating vendor library document:", error);
      throw error;
    }
  },

  // Delete vendor library document
  deleteVendorLibraryDocument: async (id: string): Promise<void> => {
    try {
      await api.vendorServiceAPI.delete(`/vendor/library/delete/${id}`);
    } catch (error) {
      console.error("Error deleting vendor library document:", error);
      throw error;
    }
  }
};

export default vendorLibraryInformation;